import React, { useContext, useState } from "react";
import { DataContext } from "./index";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridColumnMenu,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Box, IconButton, Tooltip, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import DateFormatter from "helper/dateFormartter";
import DateTimeFormatter from "helper/dateTimeFormartter";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from "@mui/icons-material/Error";
import ErrorAlert from "helper/errorAlert";
import SuccessAlert from "helper/successAlert";
import axios from "axios";
import { UploadFile } from "@mui/icons-material";
import moment from 'moment';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useApiClient } from "context/ApiClientContext";
import AgGridListing from "./agGridListing";

// Toggle this boolean to switch between the original MUI Grid (false) and the new free AG Grid Community (true)
const USE_AG_GRID = true;

export default function Listing(props) {
  const { isCheckbox } = props;
  const { isSoftDelete } = props;
  const rows = useContext(DataContext);
  const dateFormatter = DateFormatter();
  const dateTimeFormatter = DateTimeFormatter();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const apiClient = useApiClient();


  const [selectedRowIds, setSelectedRowIds] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

    // const getCurrentDatetime = () => {
    //   return moment().format('YYYYMMDD_HHmmss');
    // };

    const getCurrentDatetime = () => {
      return moment().format('YYYYMMDDHHmm');
    };
    
  const columns = [
    {
      field: "Actions",
      headerName: "",
      width: 50,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <Link to={`/account-payable/${params.id}`}>
          <IconButton color="primary">
            <Tooltip title="View Transaction" placement="right">
              <InfoIcon />
            </Tooltip>
          </IconButton>
        </Link>,
      ],
    },
    {
      field: "supplier_Name",
      headerName: "Supplier Name",
      width: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.value}
        </div>
      ),
    },
    { field: "docNum", headerName: "Invoice Number", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <React.Fragment>
          {params.value}
          {params.row.remark && (
            <IconButton>
              <Tooltip title={params.row.remark} placement="bottom">
                <ErrorIcon color="error" fontSize="small" />
              </Tooltip>
            </IconButton>
          )}
        </React.Fragment>
      ),
    },
    {
      field: "docDate",
      headerName: "Invoice Date",
      width: 200,
      type: "date",
      valueGetter: ({ row }) =>
        row.docDate ? new Date(row.docDate) : null,
      valueFormatter: ({ value }) => dateFormatter.format(value),
    },
    { field: "typeCode_Value", headerName: "Type Code Value", width: 150 },

    {
      field: "docDueDate",
      headerName: "Invoice Due Date",
      width: 150,
      type: "date",
      valueGetter: ({ row }) =>
        row.docDueDate ? new Date(row.docDueDate) : null,
      valueFormatter: ({ value }) => dateFormatter.format(value),
    },

    // { field: "eDocNum", headerName: "Long ID" },
    { field: "version", headerName: "Version"},
    { field: "longid",  width: 250, headerName: "Long Id", },
    {
      field: "remark",
      headerName: "Remark",
      width: 1,
    },
    {
      field: "addedDate",
      headerName: "Added Date",
      width: 200,
      type: "date",
      valueGetter: ({ row }) =>
        row.addedDate ? new Date(row.addedDate) : null,
      valueFormatter: ({ value }) => dateTimeFormatter.format(value),
    },
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      type: "date",
      valueGetter: ({ row }) =>
        row.updatedDate ? new Date(row.updatedDate) : null,
      valueFormatter: ({ value }) => dateTimeFormatter.format(value),
    },
    { field: "currency", headerName: "Currency", },

    {
      field: "total_PayableAmt",
      headerName: "Total Amount",
      width: 150,
      type: "number",
      renderCell: (params) => (
        <span>{formatAmount(params.value, params.row.currency)}</span>
      ),
    },

    { field: "submissionuuid",
     headerName: "Submission UUID",
     width: 250, 
    valueGetter: ({ row }) => row?.submissionuuid || "-",
  },

    { field: "docuuid",
     headerName: "Document UUID",
     width: 250, 
    valueGetter: ({ row }) => row?.docuuid || "-",
  },

    {
      field: "submitdate",
      headerName: "Submit IRB Date",
      width: 200,
      type: "date",
      valueGetter: ({ row }) =>
        row.submitdate ? new Date(row.submitdate) : null,
      valueFormatter: ({ value }) => {
        if (!value) return "-";
        
        const currentDate = new Date();
        const fortyYearsAgo = new Date();
        fortyYearsAgo.setFullYear(currentDate.getFullYear() - 40);
    
        const dateValue = new Date(value);
        
        if (dateValue < fortyYearsAgo || dateValue > currentDate) {
          return "-";
        }
    
        return dateTimeFormatter.format(dateValue);
      },
    },

    {
      field: "validatedate",
      headerName: "IRB Validated Date",
      width: 200,
      type: "date",
      valueGetter: ({ row }) =>
        row.validatedate ? new Date(row.validatedate) : null,
      valueFormatter: ({ value }) => {
        if (!value) return "-";
        
        const currentDate = new Date();
        const fortyYearsAgo = new Date();
        fortyYearsAgo.setFullYear(currentDate.getFullYear() - 40);
    
        const dateValue = new Date(value);
        
        if (dateValue < fortyYearsAgo || dateValue > currentDate) {
          return "-";
        }
    
        return dateTimeFormatter.format(dateValue);
      },
    }
  ];

  const [columnVisibilityModel, setColumnVisibilityModel] = useState();

  const callbackFunction = (data) => {
    setSelectedRowIds(data);
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));
  
  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <svg
          style={{ flexShrink: 0 }}
          width="240"
          height="200"
          viewBox="0 0 184 152"
          aria-hidden
          focusable="false"
        >
          <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
              <ellipse
                className="ant-empty-img-5"
                cx="67.797"
                cy="106.89"
                rx="67.797"
                ry="12.668"
              />
              <path
                className="ant-empty-img-1"
                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
              />
              <path
                className="ant-empty-img-2"
                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
              />
              <path
                className="ant-empty-img-3"
                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
              />
            </g>
            <path
              className="ant-empty-img-3"
              d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
            />
            <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
              <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
              <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
            </g>
          </g>
        </svg>
        <Box sx={{ mt: 1 }}>No Rows</Box>
      </StyledGridOverlay>
    );
  }
  
  function CustomToolbar({ isCheckbox, isSoftDelete }) {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fileName: `QInvo_Export_${getCurrentDatetime()}`,
          }}
        />
        {isCheckbox && (
          <Button
            disabled={!selectedRowIds.length}
            startIcon={<UploadFile />}
            onClick={() => handleSubmit(false)}
            variant="text"
            size="small"
          >
            Submit
          </Button>
        )}
        {isSoftDelete && (
          <Button
            disabled={!selectedRowIds.length}
            startIcon={<DeleteForeverOutlinedIcon />}
            onClick={() => handleSubmit(true)}
            variant="text"
            size="small"
          >
            Delete
          </Button>
        )}
      </GridToolbarContainer>
    );
  }
  
  const handleSubmit = (isVoid) => {
    bulkSubmit(isVoid);
  };
  
  function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          columnMenuColumnsItem: null,
          columnMenuSortItem: null,
          columnMenuFilterItem: null,
        }}
      />
    );
  }
  
  const formatAmount = (value, currency) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "MYR",
    })
      .format(value)
      .replace(/^(\D+)/, "");
  };

  const bulkSubmit = async (isVoid = false) => {
    const newArray = selectedRowIds.map((data) => {
      if (isVoid) {
        // Return "Void" structure
        return {
          id: data.id,
          companyId: localStorage.getItem("companyId"),
          status: "Void",
          userid: localStorage.getItem("loggedInID"),
        };
      } else {
        // Return "Pending" structure
        return {
          id: data.id,
          companyId: localStorage.getItem("companyId"),
          status: "Pending",
          remark: "",
          userid: localStorage.getItem("loggedInID"),
          irbinvoice: "",
        };
      }
    });
  
    try {
      handleOpen();
  
      const response = await axios.put(
        `${apiClient}/${localStorage.getItem("companyId")}/document/headerstatus`,
        {
          bulkdocument: newArray,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
  
      const datas = response.data;
      const message = isVoid
        ? "The selected invoices have been voided."
        : "The selected invoices are waiting to send to IRB";
  
      SuccessAlert(datas, message);
    } catch (error) {
      ErrorAlert(error);
      console.error("An error occurred:", error.response);
    } finally {
      setTimeout(() => {
        // setLoading(false);
        handleClose();
        window.location.reload();
      }, 2000);
    }
  };

  return (
    <div>
      <Box
        m="8px 0 0 0"
        style={{ height: 600, width: "100%" }}
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            display: "flex",
            justifyContent: "space-around",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.grey[600],
            color: `${colors.primary[100]} !important`,
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.grey[800],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.grey[600],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.grey[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
            display: "flex",
            justifyContent: "space-around",
          },
          "& .MuiDataGrid-columnHeader[data-field='remark']": {
            display: "none !important",
          },
          "& .MuiDataGrid-cell[data-field='remark']": {
            display: "none !important",
          },
        }}
      >
         <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        {/* <Box display="flex" justifyContent="end">
          <Button variant="contained" size="small" onClick={bulkSubmit} sx={{}}>
            Submit
          </Button>
        </Box> */}
        {USE_AG_GRID ? (
          <AgGridListing
            {...props}
          />
        ) : (
          <DataGridPro
            density="compact"
            checkboxSelection={isCheckbox || isSoftDelete}
            rows={rows}
            columns={columns}
            sx={{ "--DataGrid-overlayHeight": "300px" }}
            pageSizeOptions={[100, 250, { value: 500, label: "500" }]}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  currency: false,
                  version: false,
                  // remark: false,
                  // addedDate: false
                },
              },
              sorting: {
                sortModel: [{ field: "updatedDate", sort: "desc" }],
              },
              filter: {
                filterModel: {
                  items: [{ field: 'docDate', operator: 'is', value: '' }],
                },
              },
            }}
            slots={{
              toolbar: () => <CustomToolbar isCheckbox={isCheckbox} isSoftDelete={isSoftDelete} />,
              noRowsOverlay: CustomNoRowsOverlay,
              columnMenu: CustomColumnMenu,
            }}
            slotProps={{
              panel: { sx: { "& .MuiPaper-root": { maxHeight: "300px" } } },
              toolbar: { csvOptions: { allColumns: true } },
              filterPanel: {
                columnsSort: "asc",
                filterFormProps: {
                  // Customize inputs by passing props
                  logicOperatorInputProps: {
                    variant: "outlined",
                    size: "small",
                  },
                  columnInputProps: {
                    variant: "outlined",
                    size: "small",
                    sx: { mt: "auto" },
                  },
                  operatorInputProps: {
                    variant: "outlined",
                    size: "small",
                    sx: { mt: "auto" },
                  },
                  valueInputProps: {
                    InputComponentProps: {
                      variant: "outlined",
                      size: "small",
                    },
                  },
                  deleteIconProps: {
                    sx: {
                      "& .MuiSvgIcon-root": { color: "#d32f2f" },
                    },
                  },
                },
                sx: {
                  // Customize inputs using css selectors
                  "& .MuiDataGrid-filterForm": { p: 2 },
                  "& .MuiDataGrid-filterForm:nth-child(even)": {
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
                  },
                  "& .MuiDataGrid-filterFormLogicOperatorInput": { mr: 2 },
                  "& .MuiDataGrid-filterFormColumnInput": { mr: 2, width: 150 },
                  "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
                  "& .MuiDataGrid-filterFormValueInput": { width: 200 },
                },
              },
              columnsPanel: {},
            }}
            pagination
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) => {
              setColumnVisibilityModel(newModel);
            }}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              // setSelectedRowIds(newRowSelectionModel);

              const selectedIds = new Set(newRowSelectionModel);
              const selectedRows = rows
                .filter((row) => selectedIds.has(row.id))
                .map(({ id }) => ({ id: id }));
              callbackFunction(selectedRows);
            }}
          />
        )}
      </Box>
    </div>
  );
}